import { motion } from 'framer-motion';
import { Nav, Panels, ProjectsItem } from '../components';
import { ProjectsList } from '../data';
import { CoverStyles, ProjectsStyles } from '../styles/styles';
import { Animations } from '../utils/animations';

const Projects = () => {
  const { parent, transition, worksTitleParent, angleTextReveal } =
    Animations();

  return (
    <>
      <Nav />
      <Panels />
      <CoverStyles />
      <ProjectsStyles
        initial={{ backgroundColor: '#0f0e0e', pointerEvents: 'none' }}
        animate={{ backgroundColor: 'transparent', pointerEvents: 'unset' }}
        exit={{
          opacity: [1, 1, 0],
          transition: { duration: 2, times: [0, 0.99, 1] },
        }}>
        <div className="title-wrapper">
          <motion.div
            variants={worksTitleParent}
            initial="initial"
            animate="animate"
            className="title">
            <motion.h1 className="word-wrapper">
              <motion.div
                variants={angleTextReveal}
                transition={transition}
                className="word">
                Passion,
              </motion.div>
            </motion.h1>
            <motion.h1 className="word-wrapper">
              <motion.div
                variants={angleTextReveal}
                transition={transition}
                className="word">
                Resilience,
              </motion.div>
            </motion.h1>
            <motion.h1 className="word-wrapper">
              <motion.div
                variants={angleTextReveal}
                transition={transition}
                className="word">
                Creativity.
              </motion.div>
            </motion.h1>
          </motion.div>
        </div>
        <div className="content">
          <motion.ul
            variants={parent}
            initial="initial"
            animate="animate"
            className="works-list tap-highlight-transparent">
            {ProjectsList.map((data) => {
              return <ProjectsItem data={data} key={data.id} />;
            })}
          </motion.ul>
        </div>
      </ProjectsStyles>
    </>
  );
};

export default Projects;
